import { useUrlFilters } from "../../../shared/hooks/useUrlFilters";
var ALL_YEARS_OPTION = "__all_years__";
var normalizeMultiValue = function (value) {
    return (Array.isArray(value) ? value : String(value).split(",")).filter(Boolean);
};
export function useMulheresFilters() {
    var _a, _b, _c, _d, _e;
    var _f = useUrlFilters(), clearFilters = _f.clearFilters, getFilter = _f.getFilter, getMultiFilter = _f.getMultiFilter, setFilter = _f.setFilter, setFilters = _f.setFilters;
    var periodo = getMultiFilter("periodo");
    var territorio = (_a = getFilter("territorio")) !== null && _a !== void 0 ? _a : "";
    var natureza = (_b = getFilter("natureza")) !== null && _b !== void 0 ? _b : "";
    var cidade = (_c = getFilter("cidade")) !== null && _c !== void 0 ? _c : "";
    var delegacia = (_d = getFilter("delegacia")) !== null && _d !== void 0 ? _d : "";
    var mes = (_e = getFilter("mes")) !== null && _e !== void 0 ? _e : "";
    var filters = {
        periodo: periodo,
        territorio: territorio,
        natureza: natureza,
        cidade: cidade,
        delegacia: delegacia,
        mes: mes,
    };
    var handleFilterChange = function (key, value) {
        if (key === "periodo") {
            var rawValues = normalizeMultiValue(value);
            var nextYears = !rawValues.includes(ALL_YEARS_OPTION)
                ? rawValues
                : filters.periodo.length === 0
                    ? rawValues.filter(function (item) { return item !== ALL_YEARS_OPTION; })
                    : [];
            var nextFilters = {
                periodo: nextYears,
            };
            if (!(nextYears.length === 1 && filters.periodo[0] === nextYears[0])) {
                nextFilters.mes = undefined;
            }
            setFilters(nextFilters);
            return;
        }
        if (key === "mes") {
            setFilter("mes", Array.isArray(value) ? value[0] || undefined : value);
            return;
        }
        if (key === "territorio") {
            var nextTerritorio = Array.isArray(value) ? value[0] || "" : value;
            var nextFilters = {
                territorio: nextTerritorio || undefined,
            };
            if (nextTerritorio !== filters.territorio) {
                nextFilters.delegacia = undefined;
                nextFilters.cidade = undefined;
            }
            setFilters(nextFilters);
            return;
        }
        if (key === "delegacia") {
            setFilter("delegacia", Array.isArray(value) ? value[0] || undefined : value || undefined);
            return;
        }
        setFilter(key, Array.isArray(value) ? value[0] || undefined : value || undefined);
    };
    return {
        filters: filters,
        handleFilterChange: handleFilterChange,
        resetFilters: clearFilters,
    };
}
